import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/admin.service';
import { UserDataService } from 'src/app/services/user-data.service';

@Component({
  selector: 'app-kanban-mails',
  templateUrl: './kanban-mails.component.html',
  styleUrls: ['./kanban-mails.component.css']
})
export class KanbanMailsComponent implements OnInit {




  sent: any[] = [];
  receivedExact: any[] = [];
  receivedDomain: any[] = [];
  receivedUnknown: any[] = [];
  sentToPrevious: any[] = [];

  constructor(
    private userData: UserDataService,
    public admin: AdminService
  ) {}

  ngOnInit(): void {
    this.userData.getAllMailsFromInbox().subscribe((data: any) => {
      this.sent = data.sent;
      this.receivedExact = data.received_exact;
      this.receivedDomain = data.received_domain;
      this.receivedUnknown = data.received_unknown;
      this.sentToPrevious = data.sent_to_previous;
    });
  }

  /**
   * Devuelve el email correspondiente en la lista que coincide con raw,
   * o el primero si no hay coincidencia.
   */
  senderEmail(list: string, raw: string): string {
    const candidates = list.split(',').map(m => m.trim().toLowerCase()).filter(m => !!m);
    const match = raw.match(/<([^>]+)>/);
    const rawEmail = (match ? match[1] : raw).trim().toLowerCase();
    return candidates.find(e => e === rawEmail) || candidates[0] || '';
  }
}
